import CanadaFrenchRedirectionModal from './CanadaFrenchRedirectionModal';

export default CanadaFrenchRedirectionModal;
